import { KycCompletionStatus } from '~/store/store.model';
import { currencyUtils } from '~/utils/currency.utils';
export const kycWarningTextsPath = 'pages.dashboard.kycWarning';
export function getKycWarning(worksAt, wasKYBApprovedDuringLast5Minutes, kycWarningTexts) {
    const { kycCompletionStatus } = worksAt || {};
    if (kycCompletionStatus === KycCompletionStatus.CompletedWithFutureRequirements) {
        return {
            testId: 'kyc-future-requirements',
            text: kycWarningTexts.message()
        };
    } else if (kycCompletionStatus === KycCompletionStatus.Incomplete && !wasKYBApprovedDuringLast5Minutes) {
        return {
            testId: 'onboarding-kyc-error',
            text: kycWarningTexts.message()
        };
    } else {
        return null;
    }
}
export function getExternalAccountWarning(worksAt) {
    var _externalAccountStatus_deficitAmount, _externalAccountStatus_bankLast4;
    var _worksAt_stripe;
    const externalAccountStatus = (_worksAt_stripe = worksAt.stripe) === null || _worksAt_stripe === void 0 ? void 0 : _worksAt_stripe.externalAccountStatus;
    if ((externalAccountStatus === null || externalAccountStatus === void 0 ? void 0 : externalAccountStatus.status) !== 'errored') return null;
    const amountCents = (_externalAccountStatus_deficitAmount = externalAccountStatus.deficitAmount) !== null && _externalAccountStatus_deficitAmount !== void 0 ? _externalAccountStatus_deficitAmount : 0;
    const amount = currencyUtils.formatDollarAmount(currencyUtils.centsToDollars(amountCents));
    const last4 = (_externalAccountStatus_bankLast4 = externalAccountStatus.bankLast4) !== null && _externalAccountStatus_bankLast4 !== void 0 ? _externalAccountStatus_bankLast4 : '';
    const bankName = externalAccountStatus.bankName;
    const accountLabel = bankName ? "".concat(bankName, " account (****").concat(last4, ")") : "bank account (****".concat(last4, ")");
    return {
        testId: 'external-account-errored-warning',
        text: "Your bank account payouts are paused. Please ensure at least ".concat(amount, " is available in your ").concat(accountLabel, ", then contact support to resume payouts.")
    };
}
